import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

import { events } from "../../utils/events";

import styles from "./caption.css";

@customElement("bp-caption")
export class Caption extends LitElement {
  static styles = styles;

  handleLinkClick(e: MouseEvent) {
    if (globalThis.window.BibleProjectApp) e.preventDefault();

    events.requestLinkOpen((e.currentTarget as HTMLAnchorElement).href);
  }

  handleSlotChange() {
    // Ensure all links are treated as "external"
    this.querySelectorAll("a").forEach((e) => {
      e.setAttribute("target", "_blank");
      e.removeEventListener("click", this.handleLinkClick);
      e.addEventListener("click", this.handleLinkClick);
    });
  }

  render() {
    return html`
      <figcaption>
        <slot @slotchange=${this.handleSlotChange}></slot>
      </figcaption>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-caption": Caption;
  }
}
